import { DefinedUseQueryResult, useQuery } from '@tanstack/react-query';
import { getPrescriptionData } from '../orders.endpoints';
import { Product, Order, ProductElectronicPrescription, OrderFile } from '../../../Models';

export type ElectronicProduct = {
    name: string;
    quantity: number;
    generic_name?: string;
    presentation?: string;
};
const config = {
    initialDataUpdatedAt: 0, // para considerar desactualizada initialData y fetchear al toque
    refetchInterval: 60 * 1000,
    refetchIntervalInBackground: false,
};
export type PrescriptionData = DefinedUseQueryResult & {
    files: OrderFile[];
    electronicProducts: ProductElectronicPrescription[];
    otcProducts: Product[];
    allPrescriptionsHaveMetadata: boolean;
};
export const usePrescriptionData = (order: Order): PrescriptionData => {
    const hook = useQuery({
        queryKey: ['getPrescriptionData', order.id],
        queryFn: ({ queryKey }) => getPrescriptionData(queryKey[1]),
        initialData: {
            files: [],
            otc_products: [],
        },
        ...config,
    });

    const { files, otc_products: otcProducts } = hook.data;
    const prescriptionsWithMetadata = files.filter((f) => !!f.certified_metadata);
    const electronicProducts: ProductElectronicPrescription[] = prescriptionsWithMetadata.flatMap(
        (file) => file.certified_metadata!.products,
    );
    const allPrescriptionsHaveMetadata =
        files.length === files.filter((f) => !!f.certified_metadata).length;

    return {
        ...hook,
        files,
        otcProducts: otcProducts || [],
        electronicProducts,
        allPrescriptionsHaveMetadata,
    };
};
